
import { defineComponent } from 'vue';
//componente da barra
export default defineComponent({
  name: "BarraLateral",
  emits: [ 'aoTemaAlterado' ],
  data() {
    return {
      modoEscuroAtivo: false,
      // estilos: {
      //   background: '#0D3B66';
      //   width: '100%'
      //   height: '100vh',
      //   padding: '1rem',
      //   textAlign: 'center',
      // }
    }
  },
  computed: {
    textoBotao() {
      if (this.modoEscuroAtivo) {
        return 'Modo claro'
      }
      else {
        return 'Modo escuro'
      }
    },
  },
  methods: {
    alterarTema() {
      this.modoEscuroAtivo = !this.modoEscuroAtivo
      this.$emit('aoTemaAlterado', this.modoEscuroAtivo)
    },
  }
});
